export default [
  {
    path: "/resources/articles",
    name: "ArticleDiscovery",
    alias: ["/articles"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles";
    }
  },
  {
    path: "/resources/articles/beginning-tips-for-writers-the-basics",
    name: "articles-beginning-tips-for-writers-the-basics",
    alias: ["/beginning-tips-for-writers-the-basics", "/articles/beginning-tips-for-writers-the-basics"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/beginning-tips-for-writers-the-basics";
    }
  },
  {
    path: "/resources/articles/conquer-procrastination-and-get-writing",
    name: "articles-conquer-procrastination-and-get-writing",
    alias: ["/conquer-procrastination-and-get-writing", "/articles/conquer-procrastination-and-get-writing"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/conquer-procrastination-and-get-writing";
    }
  },
  {
    path: "/resources/articles/perfectionism-distracts-you-from-writing-perfectly",
    name: "articles-perfectionism-distracts-you-from-writing-perfectly",
    alias: ["/perfectionism-distracts-you-from-writing-perfectly", "/articles/perfectionism-distracts-you-from-writing-perfectly"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/perfectionism-distracts-you-from-writing-perfectly";
    }
  },
  {
    path: "/resources/articles/beginning-tips-for-writers-working-styles-and-wip",
    name: "articles-beginning-tips-for-writers-working-styles-and-wip",
    alias: ["/beginning-tips-for-writers-working-styles-and-wip", "/articles/beginning-tips-for-writers-working-styles-and-wip"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/beginning-tips-for-writers-working-styles-and-wip";
    }
  },
  {
    path: "/resources/articles/after-the-first-draft-pro-tips-for-editing-your-work",
    name: "articles-after-the-first-draft-pro-tips-for-editing-your-work",
    alias: ["/after-the-first-draft-pro-tips-for-editing-your-work", "/articles/after-the-first-draft-pro-tips-for-editing-your-work"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/after-the-first-draft-pro-tips-for-editing-your-work";
    }
  },
  {
    path: "/resources/articles/five-geeky-hobbies-for-writers-that-arent-reading",
    name: "articles-five-geeky-hobbies-for-writers-that-arent-reading",
    alias: ["/five-geeky-hobbies-for-writers-that-arent-reading", "/articles/five-geeky-hobbies-for-writers-that-arent-reading"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/five-geeky-hobbies-for-writers-that-arent-reading";
    }
  },
  {
    path: "/resources/articles/attending-the-muse-or-your-writing-discipline",
    name: "articles-attending-the-muse-or-your-writing-discipline",
    alias: ["/attending-the-muse-or-your-writing-discipline", "/articles/attending-the-muse-or-your-writing-discipline"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/attending-the-muse-or-your-writing-discipline";
    }
  },
  {
    path: "/resources/articles/its-okay-to-be-edited-really",
    name: "articles-its-okay-to-be-edited-really",
    alias: ["/its-okay-to-be-edited-really", "/articles/its-okay-to-be-edited-really"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/its-okay-to-be-edited-really";
    }
  },
  {
    path: "/resources/articles/5-simple-habits-to-boost-your-writing",
    name: "articles-5-simple-habits-to-boost-your-writing",
    alias: ["/5-simple-habits-to-boost-your-writing", "/articles/5-simple-habits-to-boost-your-writing"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/five-simple-habits-to-boost-your-writing";
    }
  },
  {
    path: "/resources/articles/4-easy-steps-to-a-writing-plan",
    name: "articles-4-easy-steps-to-a-writing-plan",
    alias: ["/4-easy-steps-to-a-writing-plan", "/articles/4-easy-steps-to-a-writing-plan"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/four-easy-steps-to-a-writing-plan";
    }
  },
  {
    path: "/resources/articles/shut-up-and-writes-nanowrimo-survival-guide",
    name: "articles-shut-up-and-writes-nanowrimo-survival-guide",
    alias: ["/shut-up-and-writes-nanowrimo-survival-guide", "/articles/shut-up-and-writes-nanowrimo-survival-guide"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/shut-up-writes-nanowrimo-survival-guide";
    }
  },
  {
    path: "/resources/articles/five-ways-to-silence-your-inner-critic-while-drafting",
    name: "articles-five-ways-to-silence-your-inner-critic-while-drafting",
    alias: ["/five-ways-to-silence-your-inner-critic-while-drafting", "/articles/five-ways-to-silence-your-inner-critic-while-drafting"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/five-ways-to-silence-your-inner-critic-while-drafting";
    }
  },
  {
    path: "/resources/articles/creating-your-writing-environment",
    name: "articles-creating-your-writing-environment",
    alias: ["/creating-your-writing-environment", "/articles/creating-your-writing-environment"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/creating-your-writing-environment";
    }
  },
  {
    path: "/resources/articles/the-writers-guide-to-editors",
    name: "articles-the-writers-guide-to-editors",
    alias: ["/the-writers-guide-to-editors", "/articles/the-writers-guide-to-editors"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/the-writers-guide-to-editors";
    }
  },
  {
    path: "/resources/articles/10-best-practices-for-writing-from-home",
    name: "articles-10-best-practices-for-writing-from-home",
    alias: ["/10-best-practices-for-writing-from-home", "/articles/10-best-practices-for-writing-from-home"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/ten-best-practices-for-writing-from-home";
    }
  },
  {
    path: "/resources/articles/the-writers-guide-to-copyright",
    name: "articles-the-writers-guide-to-copyright",
    alias: ["/the-writers-guide-to-copyright", "/articles/the-writers-guide-to-copyright"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/the-writers-guide-to-copyright";
    }
  },
  {
    path: "/resources/articles/seven-strategies-to-get-you-writing-again",
    name: "articles-seven-strategies-to-get-you-writing-again",
    alias: ["/seven-strategies-to-get-you-writing-again", "/articles/seven-strategies-to-get-you-writing-again"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/seven-strategies-to-get-you-writing-again";
    }
  },
  {
    path: "/resources/articles/four-essential-steps-to-developing-your-writing-practice",
    name: "articles-four-essential-steps-to-developing-your-writing-practice",
    alias: ["/four-essential-steps-to-developing-your-writing-practice", "/articles/four-essential-steps-to-developing-your-writing-practice"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/four-essential-steps-to-developing-your-writing-practice";
    }
  },
  {
    path: "/resources/articles/how-to-get-feedback-on-your-writing",
    name: "articles-how-to-get-feedback-on-your-writing",
    alias: ["/how-to-get-feedback-on-your-writing", "/articles/how-to-get-feedback-on-your-writing"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/how-to-get-feedback-on-your-writing";
    }
  },
  {
    path: "/resources/articles/tricks-for-writing-under-pressure",
    name: "articles-tricks-for-writing-under-pressure",
    alias: ["/tricks-for-writing-under-pressure", "/articles/tricks-for-writing-under-pressure"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/tricks-for-writing-under-pressure";
    }
  },
  {
    path: "/resources/articles/how-to-get-a-book-cover-youre-proud-of",
    name: "articles-how-to-get-a-book-cover-youre-proud-of",
    alias: ["/how-to-get-a-book-cover-youre-proud-of", "/articles/how-to-get-a-book-cover-youre-proud-of"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/how-to-get-a-book-cover-youre-proud-of";
    }
  },
  {
    path: "/resources/articles/finding-and-working-with-a-beta-reader",
    name: "articles-finding-and-working-with-a-beta-reader",
    alias: ["/finding-and-working-with-a-beta-reader", "/articles/finding-and-working-with-a-beta-reader"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/finding-and-working-with-a-beta-reader";
    }
  },
  {
    path: "/resources/articles/how-i-completed-my-first-novel-with-the-help-of-shut-up-and-write",
    name: "articles-how-i-completed-my-first-novel-with-the-help-of-shut-up-and-write",
    alias: ["/how-i-completed-my-first-novel-with-the-help-of-shut-up-and-write", "/articles/how-i-completed-my-first-novel-with-the-help-of-shut-up-and-write"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/how-i-completed-my-first-novel-with-the-help-of-shut-up-write";
    }
  },
  {
    path: "/resources/articles/how-to-edit-the-first-draft-of-your-novel",
    name: "articles-how-to-edit-the-first-draft-of-your-novel",
    alias: ["/how-to-edit-the-first-draft-of-your-novel", "/articles/how-to-edit-the-first-draft-of-your-novel"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/how-to-edit-the-first-draft-of-your-novel";
    }
  },
  {
    path: "/resources/articles/between-editing-and-submission",
    name: "articles-between-editing-and-submission",
    alias: ["/between-editing-and-submission", "/articles/between-editing-and-submission"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/between-editing-and-submission";
    }
  },
  {
    path: "/resources/articles/how-to-find-a-literary-agent",
    name: "articles-how-to-find-a-literary-agent",
    alias: ["/how-to-find-a-literary-agent", "/articles/how-to-find-a-literary-agent"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/how-to-find-a-literary-agent";
    }
  },
  {
    path: "/resources/articles/make-writing-a-habit-not-a-choice",
    name: "articles-make-writing-a-habit-not-a-choice",
    alias: ["/make-writing-a-habit-not-a-choice", "/articles/make-writing-a-habit-not-a-choice"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/make-writing-a-habit-not-a-choice";
    }
  },
  {
    path: "/resources/articles/staying-creative-while-the-world-is-burning",
    name: "articles-staying-creative-while-the-world-is-burning",
    alias: ["/staying-creative-while-the-world-is-burning", "/articles/staying-creative-while-the-world-is-burning"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/staying-creative-while-the-world-is-burning";
    }
  },
  {
    path: "/resources/articles/how-to-self-edit-in-six-painless-steps",
    name: "articles-how-to-self-edit-in-six-painless-steps",
    alias: ["/how-to-self-edit-in-six-painless-steps", "/articles/how-to-self-edit-in-six-painless-steps"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/how-to-self-edit-in-six-painless-steps";
    }
  },
  {
    path: "/resources/articles/should-you-self-publish-or-traditionally-publish",
    name: "articles-should-you-self-publish-or-traditionally-publish",
    alias: ["/should-you-self-publish-or-traditionally-publish", "/articles/should-you-self-publish-or-traditionally-publish"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/should-you-self-publish-or-traditionally-publish";
    }
  },
  {
    path: "/resources/articles/how-to-work-with-an-illustrator",
    name: "articles-how-to-work-with-an-illustrator",
    alias: ["/how-to-work-with-an-illustrator", "/articles/how-to-work-with-an-illustrator"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/how-to-work-with-an-illustrator";
    }
  },
  {
    path: "/resources/articles/how-to-keep-your-writing-on-track",
    name: "articles-how-to-keep-your-writing-on-track",
    alias: ["/how-to-keep-your-writing-on-track", "/articles/how-to-keep-your-writing-on-track"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/how-to-keep-your-writing-on-track";
    }
  },
  {
    path: "/resources/articles/the-elements-of-storytelling-for-novelists",
    name: "articles-the-elements-of-storytelling-for-novelists",
    alias: ["/the-elements-of-storytelling-for-novelists", "/articles/the-elements-of-storytelling-for-novelists"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/the-elements-of-storytelling-for-novelists";
    }
  },
  {
    path: "/resources/articles/five-steps-to-improve-pacing-in-your-story",
    name: "articles-five-steps-to-improve-pacing-in-your-story",
    alias: ["/five-steps-to-improve-pacing-in-your-story", "/articles/five-steps-to-improve-pacing-in-your-story"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/five-steps-to-improve-pacing-in-your-story";
    }
  },
  {
    path: "/resources/articles/submissions-the-harsh-reality-and-how-to-improve-your-odds",
    name: "articles-submissions-the-harsh-reality-and-how-to-improve-your-odds",
    alias: ["/submissions-the-harsh-reality-and-how-to-improve-your-odds", "/articles/submissions-the-harsh-reality-and-how-to-improve-your-odds"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/submissions-the-harsh-reality-and-how-to-improve-your-odds";
    }
  },
  {
    path: "/resources/articles/five-ways-to-create-new-settings-in-your-writing",
    name: "articles-five-ways-to-create-new-settings-in-your-writing",
    alias: ["/five-ways-to-create-new-settings-in-your-writing", "/articles/five-ways-to-create-new-settings-in-your-writing"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/five-ways-to-create-new-settings-in-your-writing";
    }
  },
  {
    path: "/resources/articles/five-traits-of-an-unforgettable-scene",
    name: "articles-five-traits-of-an-unforgettable-scene",
    alias: ["/five-traits-of-an-unforgettable-scene", "/articles/five-traits-of-an-unforgettable-scene"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/five-traits-of-an-unforgettable-scene";
    }
  },
  {
    path: "/resources/articles/when-should-i-call-myself-a-writer",
    name: "articles-when-should-i-call-myself-a-writer",
    alias: ["/when-should-i-call-myself-a-writer", "/articles/when-should-i-call-myself-a-writer"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/when-should-i-call-myself-a-writer";
    }
  },
  {
    path: "/resources/articles/what-should-i-write-about-five-ways-to-find-new-writing-ideas",
    name: "articles-what-should-i-write-about-five-ways-to-find-new-writing-ideas",
    alias: ["/what-should-i-write-about-five-ways-to-find-new-writing-ideas", "/articles/what-should-i-write-about-five-ways-to-find-new-writing-ideas"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/what-should-i-write-about-five-ways-to-find-new-writing-ideas";
    }
  },
  {
    path: "/resources/articles/i-wrote-1000-words-for-30-days-and-here-is-what-happened",
    name: "articles-i-wrote-1000-words-for-30-days-and-here-is-what-happened",
    alias: ["/i-wrote-1000-words-for-30-days-and-here-is-what-happened", "/articles/i-wrote-1000-words-for-30-days-and-here-is-what-happened"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/articles/i-wrote-1000-words-for-30-days-and-here-is-what-happened";
    }
  }
];
